import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import ResultTable from '../ResultTable/ResultTable'
import styled from 'styled-components'
import { useQuery } from "@apollo/client";
import { SEARCH_QUERY } from './Queries/SearchQuery'
import { Black, Shadow, WerfenColor } from '../../Constants/ColorChart'
import { connect } from 'react-redux'
import {
    getFields as getFieldsToShow,
    processAsPlaylist,
    processAsResource,
    triggerVisitToSearchAnalytics
} from "../../../../web/Utils/utils";
import { setDocument } from '../../../actions/documentViewer'
import { hideAutoSuggest, hideModalBokecc, hideSearchBar, showBackArrow, showSearchBar } from '../../../actions/ui'
import Loader from '../Loader/Loader'
import isElectron from 'is-electron'
import { Modal } from "react-bootstrap";
import { refreshSearch, setSearchString } from "../../../actions/search";
import { logOut } from "../../../actions/session";
import { bindActionCreators } from "redux";
import Dialog from "../Dialog/Dialog";

let electron;

if ( isElectron () ) {
    electron = window.require ( "electron" )
}
const ipcRenderer = electron && electron.ipcRenderer;

/*
 *  @Description:   Component that renders search results.
 */

const StyledDiv = styled.div`
  margin-top: 110px;
  width: calc(100% - 20px);
  margin-left: auto;
  margin-right:auto;
  @media (min-width: 765px){
      margin-top: 150px;
      width: 90%;
  }
`;

const StyledModalBody = styled.div`
    height: 0px;
    padding-bottom: 50%;
    iframe {
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;
        width: 100%;
        height: 100%;
    }
`;
const Search = ( props ) => {
    let history = useHistory ();
    const [ downloadedIds, setDownloadedIds ] = useState ( [] );
    const [ has404, setHas404 ] = useState ( [] );

    const {
        settings,
        BUfilterArray,
        DfilterArray,
        FEfilterArray,
        TypeFilterArray,
        DateFilterArray,
        searchString
    } = props;
    const business_units_filter = BUfilterArray.length > 0 ? BUfilterArray : [];
    const departments_filter = DfilterArray.length > 0 ? DfilterArray : [];
    const file_extensions_filter = FEfilterArray.length > 0 ? FEfilterArray : [];
    const types_filter = TypeFilterArray.length > 0 ? TypeFilterArray : [];
    const dates_filter = DateFilterArray.length > 0 ? DateFilterArray : [];

    useEffect ( () => {
        props.showSearchBar ();
        props.showBackArrow ();
        props.hideAutoSuggest ();

        if ( props.searchString === "" || props.searchString === undefined ) {
            const currentSearchTerm = history.location.pathname.replace ( "/search/", "" );
            if ( currentSearchTerm && currentSearchTerm !== "" ) {
                const encodedQuery = encodeURIComponent ( currentSearchTerm ).split ( "%20" ).join ( " " );
                props.setSearchString ( encodedQuery );
                triggerVisitToSearchAnalytics ( encodedQuery, props.session.user );
            }
        }

        if ( isElectron () ) {
            ipcRenderer.on ( "deletionFinished", getDownloadedIds );
            ipcRenderer.on ( "indexationFinished", getDownloadedIds );
            ipcRenderer.on ( "finishedGetDownloadedIds", storeDownloadedIds );

            ipcRenderer.send ( "getDownloadedItems", "ids" );
        }

        return () => {
            props.hideSearchBar ();
            if ( isElectron () ) {
                ipcRenderer.off ( "deletionFinished", getDownloadedIds );
                ipcRenderer.off ( "indexationFinished", getDownloadedIds );
                ipcRenderer.off ( "finishedGetDownloadedIds", storeDownloadedIds );
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [] );

    useEffect ( () => {
        if ( isElectron () ) {
            ipcRenderer.send ( "getDownloadedItems", "ids" );
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ props.download.length ] );

    const getDownloadedIds = () => {
        ipcRenderer.send ( "getDownloadedItems", "ids" );
    }
    const storeDownloadedIds = ( event, downloadedItems ) => {
        setDownloadedIds ( downloadedItems.map ( item => item.id ) );
        setHas404 ( downloadedItems.filter ( item => item.is404 === true ).map ( item => item.id ) )
    }

    const createMarkup = ( html ) => {
        return { __html: html }
    }

    const classifyContents = ( results ) => {
        let playlists = [];
        let resources = [];
        let media = [];

        // eslint-disable-next-line
        results.map ( ( res ) => {

            if ( res && res.entityBundle === "playlist" ) {
                const playlist = processAsPlaylist ( res );
                playlist.actions.isDownloaded = downloadedIds.includes ( playlist.id );
                playlist.isDownloading = props.playlistDownloadQueue.includes ( playlist.id )
                playlists.push ( playlist );

            } else if ( res && res.entityBundle === "resource" ) {
                if ( res.fieldResourceFilesByFormat.length > 0 ) {
                    const resource = processAsResource ( res );
                    resource.isDownloading = props.download.map(item => item.resourceId).includes(resource.id);
                    resource.actions.isDownloaded = downloadedIds.includes ( resource.id )
                    resource.is404 = has404.includes ( resource.id )
                    resources.push ( resource )
                }
            } else {
                media.push ( res );
            }

        } );
        const playlistsFields = [ "title" ];

        let fieldsExcludes = [ "filename", "filesize", "entityBundle", "entityChanged", "entityCreated", "description", "tags"];
        if (process.env.REACT_APP_SEE_VERSION !== "1") {
          fieldsExcludes.push("version");
        }

        const resourcesFields = resources[0] ? getFieldsToShow(resources[0].metadata, fieldsExcludes) : playlistsFields;

        return { playlists, playlistsFields, resources, resourcesFields, media };
    }


    const response = useQuery ( SEARCH_QUERY, {
        variables: {
            "query": searchString || "",
            "business_units": business_units_filter,
            "departments": departments_filter,
            "file_extensions": file_extensions_filter,
            "types": types_filter,
            "dates": dates_filter,
            "limit": 50,
            "offset": 0
        },
        notifyOnNetworkStatusChange: true,
        returnPartialData: true,
        partialRefetch: true,
        errorPolicy: "all",
        skip: searchString.trim () === ""
    } );

    const { loading, data, errors } = response;

    if ( loading ) {
        return (
            <StyledDiv>
                <Loader
                    message="Searching content"
                    primaryColor={ WerfenColor }
                    secondaryColor={ Shadow }
                    fontColor={ Black }
                    extraStyle="margin-top: 10%"
                />
            </StyledDiv>
        )
    }

    if ( errors ) {
        return (
            <StyledDiv>
                <div>
                    <h1>No data recovered</h1>
                </div>
            </StyledDiv>
        )
    }

    if ( !data || Object.keys ( data ).length === 0 ) {
        return null
    }

    const results = ( data.search && data.search.results[0] ) || [];
    const { playlists, playlistsFields, resources, resourcesFields, media } = classifyContents ( results ) || [];
    const fieldsForFiles = ["name", "size", "mimetype", "language"];
    const mediaIds = media.map (item => item.entityId);
    let files = [];
    files = mediaIds.map(id => {
        const metadataForAllFiles = resources.map(resource => {
            const metadataFromResourceForFile = resource.filesInResource.map((file, key) => {
                if (file.file_id !== id) {
                    return {};
                }

                // Get the metadata needed for the ResultTable component from the resource the files are linked to
                return Object.assign(file, {
                    actions: resource.actions,
                    activities: resource.activities,
                    metadata: Object.assign(file.metadata, {fileIndex: key}),
                    saveAs: resource.saveAs,
                });
            })

            return metadataFromResourceForFile.filter(item => Object.keys(item).length !== 0);
        })

        return metadataForAllFiles.filter(item => Object.keys(item).length !== 0).flat();
    }).flat();

    const noDataToShow = playlists.length === 0 && resources.length === 0 && files.length === 0;

    return (
        <div className={ "Search" }>
            <StyledDiv>
                {
                    files.length > 0 &&
                    <ResultTable
                        rowWidth={ 80 }
                        title="Files"
                        fieldsToShow={ fieldsForFiles }
                        data={ files }
                        type={ "resource_detail" }
                        tableUnified={false}
                    />
                }

                {
                    files.length === 0 &&
                    settings.playlistsFirst &&
                    playlists.length > 0 &&
                    <ResultTable
                        rowWidth={ 80 }
                        title="Playlists"
                        fieldsToShow={ playlistsFields }
                        data={ playlists }
                        type={ "search_playlist_first" }
                        tableUnified={false}
                    />
                }

                {
                    resources.length > 0 &&
                    <ResultTable
                        rowWidth={ 80 }
                        title="Resources"
                        fieldsToShow={ resourcesFields }
                        data={ resources }
                        type={ "search_resource" }
                        tableUnified={false}
                    />
                }

                {
                    files.length === 0 &&
                    ( !settings.playlistsFirst ) &&
                    playlists.length > 0 &&
                    <ResultTable
                        rowWidth={ 80 }
                        title="Playlists"
                        fieldsToShow={ playlistsFields }
                        data={ playlists }
                        type={ "search_playlist_last" }
                        tableUnified={false}
                    />
                }
                { noDataToShow && <p>No data to show</p> }
            </StyledDiv>
            <Modal show={ props.visibleModalBokecc }
                   onHide={ props.hideModalBokecc }
                   size="lg"
                   backdrop="static"
            >
                <Modal.Header closeButton>
                    <Modal.Title>{ props.modalTitle }</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <StyledModalBody dangerouslySetInnerHTML={ createMarkup ( props.modalBody ) }/>
                </Modal.Body>
            </Modal>
            { props.dialogVisible &&
                <Dialog/>
            }
        </div>

    )
}

const mapStateToProps = ( state ) => ( {
    settings: state.settings,
    download: state.download.download,
    playlistDownloadQueue: state.downloadManager.playlistDownloadQueue,
    session: state.session,
    refresh: state.search.haveToSearch,
    searchString: state.search.searchString,
    businessUnits: state.settings.businessUnits,
    BUfilterArray: state.filters.BUfilterArray,
    departments: state.settings.departments,
    DfilterArray: state.filters.DfilterArray,
    fileExtensions: state.settings.fileExtensions,
    FEfilterArray: state.filters.FEfilterArray,
    TypeFilterArray: state.filters.TypeFilterArray,
    types: state.settings.types,
    DateFilterArray: state.filters.DateFilterArray,
    dates: state.settings.dates,
    showAutoSuggestPanel: state.ui.showAutoSuggestPanel,
    visibleModalBokecc: state.ui.visibleModalBokecc,
    modalTitle: state.ui.modalTitle,
    modalBody: state.ui.modalBody,
    expandedByDefault: state.settings.expandedByDefault,
    dialogVisible: state.ui.dialogVisible,
} );

const mapDispatchToProps = ( dispatch ) => {
    return bindActionCreators ( {
        setSearchString: setSearchString,
        refreshSearch: refreshSearch,
        setDocument: setDocument,
        showBackArrow: showBackArrow,
        hideAutoSuggest: hideAutoSuggest,
        hideModalBokecc: hideModalBokecc,
        showSearchBar: showSearchBar,
        hideSearchBar: hideSearchBar,
        logOut: logOut,
    }, dispatch );
};


export default connect ( mapStateToProps, mapDispatchToProps ) ( Search );
